import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    jobStatusState: '',
    jobIdState: '',
    fromDateState: '',
    toDateState: '',
    passportNoState: '',
    departmentIdState: '',
    masterProcessIdState: '',
    processIdState: '',
    clearFilterFlag: 0,
    departmentList: [],
    masterProcessList: [],
    processList: [],
}

const JobFilterSlice = createSlice({
    name: 'jobFilter',
    initialState,
    reducers: {
        getJobStatus(state, action) {
            state.jobStatusState = action.payload;
        },
        getJobId(state, action) {
            state.jobIdState = action.payload;
        },
        getFromDate(state, action) {
            state.fromDateState = action.payload;
        },
        getToDate(state, action) {
            state.toDateState = action.payload;
        },
        getDepartmentId(state, action) {
            state.departmentIdState = action.payload;
        },
        getMasterProcessId(state, action) {
            state.masterProcessIdState = action.payload;
        },
        getProcessId(state, action) {
            state.processIdState = action.payload;
        },
        getPassportNo(state, action) {
            state.passportNoState = action.payload;
        },
        getClearFilterFlag(state, action) {
            state.clearFilterFlag = action.payload;
        },
        getDepartmentList(state, action) {
            state.departmentList = action.payload;
        },
        getMasterProcessList(state, action) {
            state.masterProcessList = action.payload;
        },
        getProcessList(state, action) {
            state.processList = action.payload;
        },
        reset(state) {
            state.jobStatusState = '';
            state.jobIdState = '';
            state.fromDateState = '';
            state.toDateState = '';
            state.passportNoState = '';
            state.departmentIdState = '';
            state.masterProcessIdState = '';
            state.processIdState = '';
            state.clearFilterFlag = 0;
            state.masterProcessList = [];
            state.processList = [];
        },
    }
});

export const { getJobStatus, getProcessId, getCspName, getJobId, getFromDate, getToDate, getDepartmentList, getMasterProcessList,
    getProcessList, getDepartmentId, getMasterProcessId, getClearFilterFlag, getPassportNo, reset } = JobFilterSlice.actions;

export default JobFilterSlice.reducer;